<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-exchange text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Ajuste de Estoque</h4>
            <small class="text-muted small">Gerenciamento de ajustes de estoque</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <div class="mr-2">
                        <b-form-input 
                            type="date" 
                            v-model="dt1" 
                            placeholder="Data Inicial"
                            class="shadow-xs" 
                            style="width: 140px; font-size: 0.9rem;"
                            @keydown.enter.native="pesquisar()">
                        </b-form-input>
                    </div>
                    <div class="mr-2">
                        <b-form-input 
                            type="date" 
                            v-model="dt2" 
                            placeholder="Data Final"
                            class="shadow-xs" 
                            style="width: 140px; font-size: 0.9rem;"
                            @keydown.enter.native="pesquisar()">
                        </b-form-input>
                    </div>
                    <div style="width: 250px">
                        <produto-pesquisa
                            @retornaId="produtoId = $event"
                            :idInicial="produtoId"
                            place="Buscar por produto..."
                            labelBotao=""
                            ref="produtopesquisa">
                        </produto-pesquisa>
                    </div>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-1"></i>
              <span class="d-none d-sm-inline">Novo Ajuste</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="12">
                      <centro-estoque-pesquisa
                          @retornaId="centroEstoqueId = $event"
                          :idInicial="centroEstoqueId"
                          label="Centro de Estoque"
                          place="Opcional - Informe o Centro de Estoque"
                          labelBotao=""
                          ref="centroEstoquePesquisa">
                      </centro-estoque-pesquisa>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    ref="tbl"
                    class="mb-0 table-finance"
                    :head-variant="isDark ? 'dark' : 'light'"
                    :dark="isDark"
                    show-empty
                    empty-text="Nenhum ajuste encontrado"
                    responsive 
                    :sticky-header="stickyHeight"
                    hover 
                    small
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    @row-clicked="clicarLinha"
                    :per-page="perPage"
                    @row-dblclicked="edit"
                    :tbody-tr-class="rowClassSelecionado"    
                    >
                  
              <template #head(COD_PRO)>
                <SetFilter label="Produto ID" v-model="filtros.COD_PRO" :options="opcoes.COD_PRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DESCRICAO)>
                <SetFilter label="Descrição" v-model="filtros.DESCRICAO" :options="opcoes.DESCRICAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(QUANT)>
                <SetFilter label="Quant Antes" v-model="filtros.QUANT" :options="opcoes.QUANT" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(QUANT_AJUSTE)>
                <SetFilter label="Quant Depois" v-model="filtros.QUANT_AJUSTE" :options="opcoes.QUANT_AJUSTE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(QUANT_PECAS)>
                <SetFilter label="Volumes Antes" v-model="filtros.QUANT_PECAS" :options="opcoes.QUANT_PECAS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(QUANT_PECAS_AJUSTE)>
                <SetFilter label="Volumes Depois" v-model="filtros.QUANT_PECAS_AJUSTE" :options="opcoes.QUANT_PECAS_AJUSTE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DATA)>
                <SetFilter label="Data" v-model="filtros.DATA" :options="opcoes.DATA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DESCRICAO_CENTRO)>
                <SetFilter label="Centro de Estoque" v-model="filtros.DESCRICAO_CENTRO" :options="opcoes.DESCRICAO_CENTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="abrirModalExcluir(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>

              <template #cell(QUANT)="row">
                {{ formatarNumero(row.item.QUANT) }}
              </template>
              <template #cell(QUANT_AJUSTE)="row">
                {{ formatarNumero(row.item.QUANT_AJUSTE) }}
              </template>
              <template #cell(QUANT_PECAS)="row">
                {{ formatarNumero(row.item.QUANT_PECAS) }}
              </template>
              <template #cell(QUANT_PECAS_AJUSTE)="row">
                {{ formatarNumero(row.item.QUANT_PECAS_AJUSTE) }}
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Modal de Confirmação de Exclusão -->
    <b-modal
        ref="modalExcluir"
        title="Confirmar Exclusão"
        ok-variant="danger"
        ok-title="Sim, Excluir"
        cancel-title="Cancelar"
        @ok="excluir"
        centered>
      <div v-if="itemExcluir">
        <p class="mb-3">Deseja realmente excluir este ajuste de estoque?</p>
        <div class="card bg-light">
          <div class="card-body">
            <p class="mb-1"><strong>Produto:</strong> {{ itemExcluir.COD_PRO }} - {{ itemExcluir.DESCRICAO }}</p>
            <p class="mb-1"><strong>Data:</strong> {{ formatarDataBR(itemExcluir.DATA) }}</p>
            <p class="mb-1"><strong>Quantidade Antes:</strong> {{ formatarNumero(itemExcluir.QUANT) }}</p>
            <p class="mb-1"><strong>Quantidade Depois:</strong> {{ formatarNumero(itemExcluir.QUANT_AJUSTE) }}</p>
            <p class="mb-1"><strong>Volumes Antes:</strong> {{ formatarNumero(itemExcluir.QUANT_PECAS) }}</p>
            <p class="mb-1"><strong>Volumes Depois:</strong> {{ formatarNumero(itemExcluir.QUANT_PECAS_AJUSTE) }}</p>
            <p class="mb-0"><strong>Centro de Estoque:</strong> {{ itemExcluir.DESCRICAO_CENTRO }}</p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import ProdutoPesquisa from '@/views/pesquisa/ProdutoPesquisa.vue'
import CentroEstoquePesquisa from '@/views/pesquisa/CentroEstoquePesquisa.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx, exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: { 
    SetFilter, 
    ProdutoPesquisa,
    CentroEstoquePesquisa
  },
  mixins: [createCecTableToolsMixin({ rowsProp: 'lista', tblRef: 'tbl', useExternalPaging: false, filters: [
    { key: 'COD_PRO', type: 'number', label: 'Produto ID' },
    { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
    { key: 'QUANT', type: 'number', label: 'Quant Antes' },
    { key: 'QUANT_AJUSTE', type: 'number', label: 'Quant Depois' },
    { key: 'QUANT_PECAS', type: 'number', label: 'Volumes Antes' },
    { key: 'QUANT_PECAS_AJUSTE', type: 'number', label: 'Volumes Depois' },
    { key: 'DATA', type: 'date', label: 'Data' },
    { key: 'DESCRICAO_CENTRO', type: 'string', label: 'Centro de Estoque' }
  ] })],

  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      itemExcluir: null,
      colunas: [
        { key: 'COD_PRO', label: 'Produto ID', sortable: true, class: 'text-right', thStyle: { width: '100px' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true, thStyle: { width: '25%' }  },
        { key: 'QUANT', label: 'Quant Antes', sortable: true, class: 'text-right' },
        { key: 'QUANT_AJUSTE', label: 'Quant Depois', sortable: true, class: 'text-right' },
        { key: 'QUANT_PECAS', label: 'Volumes Antes', sortable: true, class: 'text-right' },
        { key: 'QUANT_PECAS_AJUSTE', label: 'Volumes Depois', sortable: true, class: 'text-right' },
        { key: 'DATA', label: 'Data do Ajuste', sortable: true, formatter: val => this.formatarDataBR(val) },
        { key: 'DESCRICAO_CENTRO', label: 'Centro de Estoque', sortable: true },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ]
    }
  }, 

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('ajusteEstoque', ['LISTA','PRODUTOID','DT1','DT2','CENTROESTOQUEID','REGISTRO_SELECIONADO_ID','RECARREGAR_LISTA']),

    lista: {
      get() { return this.LISTA },
      set(v) { this.$store.commit('ajusteEstoque/SET_LISTA', v) }
    },
    produtoId: {
      get() { return this.$store.getters['ajusteEstoque/PRODUTOID'] },
      set(v) { this.$store.commit('ajusteEstoque/SET_PRODUTOID', v) }
    },
    dt1: {
      get() { return this.$store.getters['ajusteEstoque/DT1'] },
      set(v) { this.$store.commit('ajusteEstoque/SET_DT1', v) }
    },
    dt2: {
      get() { return this.$store.getters['ajusteEstoque/DT2'] },
      set(v) { this.$store.commit('ajusteEstoque/SET_DT2', v) }
    },
    centroEstoqueId: {
      get() { return this.$store.getters['ajusteEstoque/CENTROESTOQUEID'] },
      set(v) { this.$store.commit('ajusteEstoque/SET_CENTROESTOQUEID', v) }
    }
  },

  methods: {
    clicarLinha(item) { this.$store.commit('ajusteEstoque/SET_REGISTRO_SELECIONADO_ID', item.CONTADOR) },
    rowClassSelecionado(item, type) { 
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['ajusteEstoque/REGISTRO_SELECIONADO_ID']
      return item.CONTADOR === selId ? 'cec-row-selected' : ''
    },
    
    scrollToSelected() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.cec-row-selected')
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 500)
      })
    },

    limparFiltro() {
      this.$store.commit('ajusteEstoque/SET_LIMPAR', null);
      this.filtroAvancado = false;
      if (this.$refs.produtopesquisa) {
        this.$refs.produtopesquisa.limpar()
      }
      if (this.$refs.centroEstoquePesquisa) {
        this.$refs.centroEstoquePesquisa.limpar()
      }
      this.pesquisar()
    },

    novo() {
      this.$router.push('/estoque/ajuste/add')
    },

    edit(item) {
      if (!item || !item.CONTADOR) return
      this.$store.commit('ajusteEstoque/SET_REGISTRO_SELECIONADO_ID', item.CONTADOR)
      this.$router.push(`/estoque/ajuste/edit/${item.CONTADOR}`)
    },

    async pesquisar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.isBusy = true
        
        const payload = {
          dt1: this.dt1,
          dt2: this.dt2,
          produtoId: this.produtoId,
          centroEstoqueId: this.centroEstoqueId
        }

        const response = await this.$http.get('/api/protected/estoque/ajuste/pesquisar', {
          params: payload
        })
        
        let dados = response.data
        if (dados && dados.data) dados = dados.data
        
        this.$store.commit('ajusteEstoque/SET_LISTA', dados)

        // Scroll para o registro selecionado após carregar os dados
        if (this.$store.getters['ajusteEstoque/REGISTRO_SELECIONADO_ID']) {
          this.scrollToSelected()
        }

      } catch (err) {
        console.error('Erro ao pesquisar Ajuste de Estoque:', err)
        this.$bvToast.toast('Erro ao pesquisar registros', { title: 'Erro', variant: 'danger' })
      } finally {
        this.isBusy = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    abrirModalExcluir(item) {
      this.itemExcluir = item
      this.$refs.modalExcluir.show()
    },

    async excluir() {
      if (!this.itemExcluir) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        const payload = {
          id: this.itemExcluir.CONTADOR,
          login: window.localStorage.getItem('login') || 'sistema'
        }

        await this.$http.post('/api/protected/estoque/ajuste/delete', payload)
        
        this.$bvToast.toast('Registro excluído com sucesso', { title: 'Sucesso', variant: 'success' })
        this.itemExcluir = null
        this.pesquisar()

      } catch (err) {
        console.error('Erro ao excluir Ajuste de Estoque:', err)
        this.$bvToast.toast('Erro ao excluir registro', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    formatarNumero(valor) {
      if (!valor && valor !== 0) return '-'
      return Number(valor).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    formatarDataBR(data) {
      if (!data) return '-'
      const d = new Date(data)
      if (isNaN(d)) return '-'
      const dia = String(d.getDate()).padStart(2, '0')
      const mes = String(d.getMonth() + 1).padStart(2, '0')
      const ano = d.getFullYear()
      return `${dia}/${mes}/${ano}`
    },

    exportarHtml() { 
      printHtmlReport({ 
        rows: this.lista, 
        columns: this.colunas, 
        systemName: 'CECWeb', 
        reportTitle: 'Listagem de Ajustes de Estoque', 
        printedBy: window.localStorage.getItem('login') ?? '—' 
      }) 
    },
    exportarExcel() { 
      exportExcelXlsx({ 
        rows: this.lista, 
        columns: this.colunas, 
        filename: 'ajuste-estoque-lista.xlsx' 
      }) 
    }
  },

  async created() {
    // Define datas padrão se não existirem
    if (!this.dt1 || !this.dt2) {
      const hoje = new Date()
      const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
      
      if (!this.dt1) {
        this.$store.commit('ajusteEstoque/SET_DT1', primeiroDiaMes.toISOString().split('T')[0])
      }
      if (!this.dt2) {
        this.$store.commit('ajusteEstoque/SET_DT2', hoje.toISOString().split('T')[0])
      }
    }

    if (this.RECARREGAR_LISTA || !this.LISTA || this.LISTA.length === 0) {
      this.$store.commit('ajusteEstoque/SET_RECARREGAR_LISTA', false)
      await this.pesquisar()
    } else {
      // Se não precisou recarregar mas tem um registro selecionado, fazer scroll
      if (this.REGISTRO_SELECIONADO_ID) {
        this.$nextTick(() => {
          this.scrollToSelected()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Scoped styles if needed */
</style>



// WEBPACK FOOTER //
// src/views/estoque/ajuste/AjusteEstoqueListagem.vue